<div class="page-title-area">
  <div class="d-table">
    <div class="d-table-cell">
      <div class="container">
        <div class="page-title-text">
          <h2>Terms and Conditions</h2>
          <ul>
            <li><a routerLink="/">Home</a></li>
            <li><i class="icofont-simple-right"></i></li>
            <li>Terms and Conditions</li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</div>

<section class="privacy-area pt-5">
  <div class="container">
    <div class="privacy-item">
      <h2>1. Introduction</h2>
      <p>1.1 Please read our Terms and conditions carefully before accessing or using the information and services available through this website. By accessing or using the Site, you agree to be bound by the terms and conditions below. Mesh Innovation Centre may modify this agreement at any time, and such modifications shall be effective immediately upon posting the modified agreement on the Site. </p>
      <p>1.2 These terms and conditions shall govern your use of this website</p>
      <p>1.3 By using our website, you accept these terms and conditions in full; accordingly, if you disagree with these terms and conditions or any part of these terms and conditions, you must not use our website. </p>
    </div>

    <div class="privacy-item">
      <h2>2. Copyright notice</h2>
      <p> 2.1 Copyright (c) 2022 Mesh Innovation Centre. </p>
      <p> 2.2 Subject to the express provisions of these terms and conditions:</p>
        <ul>
          <li>
            (a) We, together with oir licensors, own and control all the copyright and other intellectual property rights in our website and the material on our website.
          </li>
          <li>
            (b) All the copyright and other intellectual property rights in our website and the material on our website are reserved.
          </li>
        </ul>
    </div>

    <div class="privacy-item">
      <h2>3. Permission to use website</h2>
      <p>3.1 You may; </p>
      <ul>
        <li>
          (a) view pages from our website in your web broswer;
        </li>
        <li>
          (b) download pages from our webistes for caching in a website;
        </li>
        <li>
          (c) print pages from our website for your personal and non-commercial use;
        </li>
        <li>
          (d) copy pages from our website for your personal and non-commercial use;
        </li>
        <li>
          (e) download pages from our website for use with a screen-printer;
        </li>
        <li>
          (f) download pages from our website for use as an electronic document;
        </li>
        <li>
          (g) use our website services;
        </li>
        <li>
          (h) use our website services for any other purpose, including, but not limited to, using our website services to send any emails, or to post any feedback, suggestions or complaints;
        </li>
      </ul>
      <p>
        3.2 Except as expressly permitted by section 3.1 or other provisions of these terms and conditions, you must not download any material from our website or save any such material to your computer.
      </p>
      <p>
        3.3 You must not use our website in any way that causes, or may cause, damage to the website or impairment of the performance, availability or accessibility of our website; or in any way which is unlawful, illegal, fraudulent or harmful, or in connection with any unlawful, illegal, fraudulent or harmful purpose or activity.
      </p>
      <p>
        3.4 You must not use our website to copy, store, host, transmit, send, use, publish or distribute any material which consists of (or is linked to) any spyware, computer virus, Trojan horse, worm, keystroke logger, rootkit or other malicious computer software.
      </p>
      <p>
        3.5 You must not conduct any systematic or automated data collection activities (including without limitation scraping, data mining, data extraction and data harvesting) on or in relation to our website without our express written consent.
      </p>
      <p>
        3.6 You must not use our website to transmit or send unsolicited commercial communications.
      </p>
      <p>
        3.7 You must not use our website for any purposes related to marketing without our express written consent.
      </p>
      <p>
        3.8 You must not use our website in any way that is unlawful, illegal, fraudulent or harmful, or in connection with any unlawful, illegal, fraudulent or harmful purpose or activity.
      </p>
      <p>
        3.9 You must not use our website to transmit or send unsolicited commercial communications.
      </p>
    </div>

    <div class="privacy-item">
      <h2>4. Jobseeker registration and accounts</h2>
      <p> 4.1 This section  applies to you if you are a Jobseeker </p>
      <p> 4.2 To be eligible for a jobseeker account, you must be at least 18 years old and have a valid email address. </p>
      <p> 4.3 You may register for an account with our website by [completing and submitting the account registration form on our website and clicking on the verification link in the email that the website will send to you].</p>
    </div>

    <div class="privacy-item">
      <h2>5. Registration registration and accounts</h2>
      <p> 5.1 This section  applies to you if you are a recruiter </p>
      <ul>
        <li> (a) To be eligible for a business account, you must be operating a business and: </li>
        <li> (b) if you are a sole trader, you must be atleast 18 years of age;</li>
      </ul>
      <p>5.2 You may register for an account with our website by [completing and submitting the account registration form on our website, and clicking on the verification link in the email that the website will send you]</p>
      <p>5.3 You must pay the fees specified on our website in relation to [your account type] </p>
    </div>
    <div class="privacy-item">
      <h2>6. Terms Of Use</h2>
      <p> 6.1 By using this site: </p>
      <ul>
        <li> (a) you agree to provide the company with requested information such as resume, personal passport pictures and others as may be required;</li>
      </ul>
    </div>
  </div>
</section>
